/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import PreviewDocumentModal from 'DesignSystem/PreviewDocumentModal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/TaskOverlay/Content/Content/Letter/Content"
  
}) {
let taskResources0DocumentTreeNodeIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'resources[0].document_tree_node.id',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<PreviewDocumentModal
  viewPath={`${viewPath}/PreviewDocumentModal`}
 data="task.resources[0].document_tree_node.id"
 documentId={taskResources0DocumentTreeNodeIdValueData}
 onSubmit={onSubmit}
/>
{children}
</React.Fragment>)
}